import { BaseApiModel } from './BaseApiModel';

export class VisumVersion extends BaseApiModel {
  public version: string;
}
